import { render, staticRenderFns } from "./BIParametersTable.vue?vue&type=template&id=4cab6eeb&"
import script from "./BIParametersTable.vue?vue&type=script&lang=js&"
export * from "./BIParametersTable.vue?vue&type=script&lang=js&"
import style0 from "./BIParametersTable.vue?vue&type=style&index=0&id=4cab6eeb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports